module.exports = __webpack_public_path__ + "static/media/naturgy_empresas_blanco.4e9f0065.png";